'use strict';
const _ = require('underscore');

module.exports = {
    startEdit: function() {
        if(this.editing) {
            return;
        }
        this.editing = true;
        this.trigger('change:edit', this);
        this._prevModelJson = _.extend({}, this.toJSON());
    },

    endEdit: function() {
        if(!this.editing) {
            return;
        }
        this.editing = false;
        this.trigger('change:edit', this);
        this._prevModelJson = null;
    },

    cancelEdit: function() {
        if(!this.editing) {
            return;
        }
        this.editing = false;
        delete this._prevModelJson.source;
        delete this._prevModelJson.target;
        this.set(this._prevModelJson);
//            this.syncState.setSynced();
        this._prevModelJson = null;
        this.trigger('change:edit', this);
    }
}



// WEBPACK FOOTER //
// ./system/domain/entity/edit-mode-mixin.js